export const RegisterFooter = () => {
  return (
    <div>
      <div className="pc:hidden">
        <MobileRegisterFooter />
      </div>
      <div className="hidden pc:block">
        <PcRegisterFooter />
      </div>
    </div>
  );
};

export const PcRegisterFooter = () => {
  return (
    <div className="flex flex-col items-center gap-16 bg-primary p-32 text-white-1">
      <div className="text-sm text-primary-3">
        Copyright © 2010 Howtelevision,Inc. All Rights Reserved.
      </div>
    </div>
  );
};

export const MobileRegisterFooter = () => {
  return (
    <div className="flex flex-col items-center gap-16 bg-primary p-32 text-white-1">
      <div className="py-12 text-center text-sm text-primary-3">
        Copyright © 2010 Howtelevision,Inc. All Rights Reserved.
      </div>
    </div>
  );
};
